import { Injectable } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from "@angular/common/http";
import { Observable, Observer } from "rxjs";
import { LlwythwrService } from "../gwasanaethau/system/llwythwr.service";

@Injectable()
export class LlwythwrRhyngGipio implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  constructor(private llwythwrService: LlwythwrService) {}

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.requests.push(req);

    this.llwythwrService.ynLlwytho.next(true);

    return new Observable((observer: Observer<HttpEvent<any>>) => {
      const subscription = next.handle(req).subscribe({
        next: (event) => {
          if (event instanceof HttpResponse) {
            this.removeRequest(req);
            this.llwythwrService.ynLlwytho.next(false);
            observer.next(event);
          }
        },
        error: (err) => {
          this.removeRequest(req);
          this.llwythwrService.ynLlwytho.next(false);
          observer.error(err);
        },
        complete: () => {
          this.removeRequest(req);
          this.llwythwrService.ynLlwytho.next(false);
          observer.complete();
        },
      });

      // Os request wedi
      return () => {
        this.removeRequest(req);
        this.llwythwrService.ynLlwytho.next(false);
        subscription.unsubscribe();
      };
    });
  }
}
